import { NavLink as RouterNavLink } from "react-router-dom";
import { pxToRem } from "@getbread/dough";
import { styled } from "@mui/material/styles";
import type { FCWithChildren } from "../../api-client/resources/types/sharedTypes";
import { STYLE_CONSTANTS } from "../../utils/global.constants";

const SubNavBarStyled = styled("div")`
	width: 100%;
	position: sticky;
	top: 0;
	background: ${({ theme }) => theme.palette.background.secondary};
	box-shadow: var(--shadow-nav);
	z-index: ${STYLE_CONSTANTS.appBarZIndex};

	@media (min-width: ${(props) => props.theme.breakpoints.values.sm}px) {
		top: ${STYLE_CONSTANTS.nav.headerHeight};
		z-index: 2;
	}
`;

export const PageTitle = styled("div")`
	display: flex;
	align-items: center;
	height: ${pxToRem(60)};
	border-bottom: 1px solid ${({ theme }) => theme.palette.colors.extraLightGrey};
`;

export const PageTabs = styled("nav")`
	height: ${pxToRem(60)};
	display: flex;
	align-items: center;
	justify-content: flex-start;
`;

export const HeaderText = styled("h1")`
	font-size: ${pxToRem(16)};
	font-weight: 500;
	padding: 0 var(--space-l);
`;

export const NavTabLink = styled(RouterNavLink)`
	transition: color ${({ theme }) => theme.transitions.duration.shorter}ms;
	font-size: ${pxToRem(16)};
	font-weight: 500;
	line-height: 1;
	padding: var(--space-s);
	text-decoration: none;
	color: ${({ theme }) => theme.palette.text.primary};
	display: flex;
	align-items: center;
	height: 100%;
	border-radius: 0;
	border-bottom: 3px solid transparent;
	width: 50%;
	justify-content: center;

	@media (min-width: ${(props) => props.theme.breakpoints.values.sm}px) {
		width: auto;
		min-width: ${pxToRem(190)};
		padding: var(--space-s) var(--space-xxl);
	}

	&.active {
		color: ${({ theme }) => theme.palette.primary.main};
		border-bottom: 3px solid ${({ theme }) => theme.palette.primary.main};
	}
`;

export const SubNavBar: FCWithChildren = ({ children }) => (
	<SubNavBarStyled className="mui-fixed">{children}</SubNavBarStyled>
);
